// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseModal {
  background-color: var(--ui-gray-darker);
  border-color: var(--ui-border-color);
  color: var(--text-secondary-color);
  border-radius: 6px;
  border: 0;
  color: var(--text-primary-color);
  position: relative;
  -webkit-box-shadow: 0 3px 9px rgba(0,0,0,0.5);
  box-shadow: 0 3px 9px rgba(0,0,0,0.5);
  background-clip: padding-box;
  outline: 0;
}
@media (min-width: 320px) {
  .BaseModal {
    width: 78%;
    min-width: 300px;
  }
}
@media (min-width: 768px) {
  .BaseModal {
    width: 600px;
  }
  .BaseModal.BaseModal-fullscreen {
    width: 95%;
  }
}
@media (min-width: 992px) {
  .BaseModal {
    width: 900px;
  }
  .BaseModal.BaseModal-fullscreen {
    width: 95%;
  }
}
.BaseModal__content {
  padding: 20px;
  max-height: 90vh;
  overflow-y: auto;
}
.BaseModal.noScroll .BaseModal__content {
  overflow: hidden;
}
.BaseModal:not(.visibleScrollbar) .BaseModal__content {
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.BaseModal:not(.visibleScrollbar) .BaseModal__content::-webkit-scrollbar {
  display: none;
}
.BaseModal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-bottom-color: #000;
  padding: 20px;
  position: relative;
}
.BaseModal__header h4 {
  color: var(--text-secondary-color);
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  padding-right: 24px;
  margin: 0;
}
.BaseModal__header button {
  cursor: pointer;
  margin: -10px 0 0 0;
  padding: 0;
  background-color: transparent;
  border: none;
  color: var(--text-secondary-color);
  font-size: 25px;
  font-weight: lighter;
}
.BaseModal__header button:active,
.BaseModal__header button:focus,
.BaseModal__header button:focus:active {
  background-image: none;
  outline: 0;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/baseModal/BaseModal.styl"],"names":[],"mappings":"AAAA;EACE,uCAAkB;EAClB,oCAAc;EACd,kCAAO;EACP,kBAAe;EACf,SAAQ;EACR,gCAAO;EACP,kBAAU;EACV,6CAAoB;EACpB,qCAAY;EACZ,4BAAiB;EACjB,UAAS;AACX;AAC0B;EAAA;IACtB,UAAO;IACP,gBAAW;EAEb;AACF;AAD0B;EAAA;IACtB,YAAO;EAIT;EAFE;IACE,UAAO;EAIX;AACF;AAH0B;EAAA;IACtB,YAAO;EAMT;EAJE;IACE,UAAO;EAMX;AACF;AALE;EACE,aAAS;EACT,gBAAY;EACZ,gBAAY;AAOhB;AALE;EACE,gBAAU;AAOd;AAJE;EACE,kBAAY;EACZ,qBAAiB;EACjB,wBAAoB;AAMxB;AALI;EACE,aAAS;AAOf;AALE;EACE,aAAS;EACT,8BAAiB;EACjB,mBAAa;EACb,wBAAqB;EACrB,0BAAqB;EACrB,yBAAqB;EACrB,aAAS;EACT,kBAAU;AAOd;AALI;EACE,kCAAO;EACP,eAAW;EACX,gBAAa;EACb,iBAAa;EACb,mBAAe;EACf,SAAQ;AAOd;AALI;EACE,eAAQ;EACR,mBAAQ;EACR,UAAS;EACT,6BAAkB;EAClB,YAAQ;EACR,kCAAO;EACP,eAAW;EACX,oBAAa;AAOnB;AALM;;;EAGE,sBAAkB;EAClB,UAAS;EACT,gBAAY;AAOpB","sourcesContent":[".BaseModal\n  background-color: var(--ui-gray-darker)\n  border-color: var(--ui-border-color)\n  color: var(--text-secondary-color)\n  border-radius: 6px\n  border: 0\n  color: var(--text-primary-color)\n  position: relative\n  -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5)\n  box-shadow: 0 3px 9px rgba(0,0,0,.5);\n  background-clip: padding-box\n  outline: 0\n\n  @media (min-width: 320px)\n    width: 78%\n    min-width: 300px\n\n  @media (min-width: 768px)\n    width: 600px\n\n    &.BaseModal-fullscreen\n      width: 95%\n\n  @media (min-width: 992px)\n    width: 900px\n\n    &.BaseModal-fullscreen\n      width: 95%\n\n  &__content\n    padding: 20px\n    max-height: 90vh;\n    overflow-y: auto;\n\n  &.noScroll &__content {\n    overflow: hidden;\n  }\n\n  &:not(.visibleScrollbar) &__content\n    overflow-x: hidden;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar\n      display: none;\n\n  &__header\n    display: flex\n    justify-content: space-between\n    align-items: center\n    border-bottom-width: 3px\n    border-bottom-style: solid\n    border-bottom-color: #000000\n    padding: 20px\n    position: relative\n\n    h4\n      color: var(--text-secondary-color)\n      font-size: 20px\n      font-weight: 500\n      line-height: 24px\n      padding-right: 24px\n      margin: 0\n\n    button\n      cursor: pointer\n      margin: -10px 0 0 0\n      padding: 0\n      background-color: transparent\n      border: none\n      color: var(--text-secondary-color)\n      font-size: 25px\n      font-weight: lighter\n\n      &:active,\n      &:focus,\n      &:focus:active\n        background-image: none\n        outline: 0\n        box-shadow: none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
